import { useEffect, useState } from "react";
import { auth } from "../Models/firebaseConfig";

/**
 * Hook to check if the user is logged in.
 */
function useLogin(): boolean | null {
  const [loggedIn, setLoggedIn] = useState<boolean | null>(null);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      const isUserLoggedIn = !!user;
      setLoggedIn(isUserLoggedIn);
    });

    return unsubscribe;
  }, []);

  return loggedIn;
}

export default useLogin;
